import { render, staticRenderFns } from "./CambioSIM.vue?vue&type=template&id=6ac90abe&"
import script from "./CambioSIM.vue?vue&type=script&lang=ts&"
export * from "./CambioSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ac90abe', component.options)
    } else {
      api.reload('6ac90abe', component.options)
    }
    module.hot.accept("./CambioSIM.vue?vue&type=template&id=6ac90abe&", function () {
      api.rerender('6ac90abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/CambioSIM.vue"
export default component.exports